module.exports = "app-resource-upload-modal-step3, app-chapter-selector {\n  margin-top: 20px; }\n"